import { Component, Input } from '@angular/core';

/**
 * side tabs component
 */
@Component({
  selector: 'def-side-tabs',
  templateUrl: './def-side-tabs.component.html',
  styleUrls: [
    './def-side-tabs_side.component.scss',
    './def-side-tabs_profil.component.scss',
  ],
})
export class DefSideTabsComponent {
  @Input() icon: string;
  @Input() title: string;
  @Input() active = false;
  @Input() last = false;
  @Input() color?: string;
  @Input() selectedTab?: 'reservation' | 'formation' | 'information' | 'space' | 'deconnexion';
}

